import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup, signInWithEmailAndPassword, createUserWithEmailAndPassword, sendPasswordResetEmail, signOut, updateProfile } from 'firebase/auth';
import { getFirestore, doc, setDoc } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyAWpizsmO9JTMB28oxmdDyuHSM3K8PeXe4",
  authDomain: "fluxara-4b54a.firebaseapp.com",
  projectId: "fluxara-4b54a",
  storageBucket: "fluxara-4b54a.firebasestorage.app",
  messagingSenderId: "330029507775",
  appId: "1:330029507775:web:22739359f062ee7b9f520a",
  measurementId: "G-65M60YY3EH"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();

// Auth functions
export const loginWithEmail = (email, password) => signInWithEmailAndPassword(auth, email, password);

export const signupWithEmail = async (email, password, displayName) => {
  const userCredential = await createUserWithEmailAndPassword(auth, email, password);
  
  // Update the user's profile with displayName in Firebase Auth
  if (displayName) {
    await updateProfile(userCredential.user, {
      displayName: displayName
    });
    
    // Wait a bit for Cloud Function to create the document, then update it with displayName
    // Cloud Function creates the document but might not have displayName yet due to timing
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    // Update Firestore document with displayName to ensure it's saved
    const userRef = doc(db, 'users', userCredential.user.uid);
    await setDoc(userRef, {
      displayName: displayName,
      updatedAt: new Date().toISOString()
    }, { merge: true });
  }
  
  return userCredential;
};

export const loginWithGoogle = () => signInWithPopup(auth, googleProvider);
export const logout = () => signOut(auth);
export const resetPassword = (email) => sendPasswordResetEmail(auth, email);

export default app;